import styled, { css } from 'styled-components';
import { getColor } from '@pleo-io/telescope-theme';
import { arc8 } from '@pleo-io/telescope-tokens';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-radius: ", ";\n    position: relative;\n    width: 100%;\n\n    &::before {\n        content: '';\n        display: block;\n        background-color: ", ";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: ", ";\n        height: 100%;\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    height: 8px;\n\n    &::before {\n        border-top-left-radius: ", ";\n        border-bottom-left-radius: ", ";\n    }\n\n    &::after {\n        content: '';\n        display: ", ";\n        width: 2px;\n        height: 12px;\n        border-radius: ", ";\n        background-color: ", ";\n        position: absolute;\n        left: ", ";\n        top: -2px;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    height: 10px;\n\n    &::before,\n    &::after {\n        border-radius: ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DEFAULT_FILL = 'green500';
var DEFAULT_BG = 'shade300';
var tallStyles = /*#__PURE__*/css( /*#__PURE__*/_templateObject(), arc8);
var slimStyles = /*#__PURE__*/css( /*#__PURE__*/_templateObject2(), arc8, arc8, function (_ref) {
  var percent = _ref.percent;
  return percent ? 'block' : 'none';
}, arc8, function (_ref2) {
  var _ref2$fillColor = _ref2.fillColor,
      fillColor = _ref2$fillColor === void 0 ? DEFAULT_FILL : _ref2$fillColor;
  return getColor(fillColor);
}, function (_ref3) {
  var percent = _ref3.percent;
  return (percent || '0') + "%";
});
var BarStyles = /*#__PURE__*/css( /*#__PURE__*/_templateObject3(), function (_ref4) {
  var _ref4$bgColor = _ref4.bgColor,
      bgColor = _ref4$bgColor === void 0 ? DEFAULT_BG : _ref4$bgColor;
  return getColor(bgColor);
}, arc8, function (_ref5) {
  var _ref5$fillColor = _ref5.fillColor,
      fillColor = _ref5$fillColor === void 0 ? DEFAULT_FILL : _ref5$fillColor;
  return getColor(fillColor);
}, function (_ref6) {
  var percent = _ref6.percent;
  return (percent || '0') + "%";
});

var getVariantStyles = function getVariantStyles(props) {
  if (props.variant === 'slim') {
    return slimStyles;
  } else if (props.variant === 'tall') {
    return tallStyles;
  }

  return BarStyles;
};

var clamp = function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
};

var ProgressBar = /*#__PURE__*/styled.div.attrs(function (_ref7) {
  var percent = _ref7.percent,
      _ref7$fillColor = _ref7.fillColor,
      fillColor = _ref7$fillColor === void 0 ? DEFAULT_FILL : _ref7$fillColor,
      _ref7$bgColor = _ref7.bgColor,
      bgColor = _ref7$bgColor === void 0 ? DEFAULT_BG : _ref7$bgColor;
  var volume = clamp(percent, 0, 100);
  return {
    role: 'progressbar',
    'aria-valuenow': volume,
    'aria-valuemin': 0,
    'aria-valuemax': 100,
    percent: volume,
    fillColor: fillColor,
    bgColor: bgColor
  };
})( /*#__PURE__*/_templateObject4(), BarStyles, getVariantStyles);
export { ProgressBar };